module.exports = __webpack_public_path__ + "img/8.77aef45d.png";